import { render, staticRenderFns } from "./DepartmentCard.vue?vue&type=template&id=1b9948d2&scoped=true&"
import script from "./DepartmentCard.vue?vue&type=script&lang=js&"
export * from "./DepartmentCard.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentCard.vue?vue&type=style&index=0&id=1b9948d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9948d2",
  null
  
)

export default component.exports